import { ModalStates } from '@components'

import { MissingCompanyDetailsModalBody } from '../elements/MissingCompanyDetailsModalBody'
import { MissingCompanyDetailsModalFooter } from '../elements/MissingCompanyDetailsModalFooter'
import { MissingCustomerDetailsModalBody } from '../elements/MissingCustomerDetailsModalBody'
import { MissingCustomerDetailsModalFooter } from '../elements/MissingCustomerDetailsModalFooter'
import { MissingComplianceDetailsModalStateId } from '../enums/missingComplianceDetailsModalStateId'

export const missingComplianceDetailsModalStates: ModalStates<MissingComplianceDetailsModalStateId> = [
  {
    id: MissingComplianceDetailsModalStateId.MissingCompanyDetails,
    headerTKey: 'external_invoices.missing_company_compliance_details.modal.header',
    modalBody: <MissingCompanyDetailsModalBody />,
    modalFooter: <MissingCompanyDetailsModalFooter />,
  },
  {
    id: MissingComplianceDetailsModalStateId.MissingCustomerDetails,
    headerTKey: 'external_invoices.missing_customer_compliance_details.modal.header',
    modalBody: <MissingCustomerDetailsModalBody />,
    modalFooter: <MissingCustomerDetailsModalFooter />,
  },
]
